import { FC } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('delta3Plus.AU2');
    const { pageStatus } = useDP3Store();

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749404311/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736837857178/au2-h5-1.jpg',
            title: t('label1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749406107/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736837857359/au2-h5-2.jpg',
            title: t('label2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749404114/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736837857599/au2-h5-3.jpg',
            title: t('label3'),
        },
    ];

    return (
        <div className={`${css.thecomp}`} id="AU_2">
            <EfSpec />
            <div className="main">
                <div className="main-top">
                    <EfSection theme="white" title={t('title')} desc={t('desc')} />
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1736837446273/au2-pc.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1736837446079/au2-h5.jpg"
                    />
                </div>
                <div className="main-bottom">
                    <EfSection theme="white" title={t('title2')} desc={t('desc2')} />
                    <ul className="list">
                        {list.map((i) => (
                            <li className="item" key={i.title}>
                                <EfImg pc={i.pc} h5={i.h5} />
                                <span>{i.title}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <EfSpec />
        </div>
    );
};

export default TheComp;
